/**
 * [平台钱包账户]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */

import React, { useState,useEffect, useRef } from 'react';
import {Button, Select, Switch, message, Tooltip} from 'antd';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import WarningModal from './components/WarningModal';
import PropTypes from 'prop-types';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import * as apis from '@/apis/finance/platformAccount';
import * as hedeApis from '@/apis/finance/hedeInsure';
import { getSystemParams, updateSystemParams } from '@/apis/common/index';
import { regFenToYuan } from '@/util/money';
import ButtonPerssion from '@/routes/ButtonPerssion';
import { SettingFilled, QuestionCircleOutlined } from '@ant-design/icons';
import TableList from './components/TableList';
import { FilterForm, FilterItem, XRangePicker, XSelect, XInput, XPagination } from '@/components/xqxc_ui';
import WithdrawalModal from './components/WithdrawalModal';
import RechargeModal from './components/RechargeModal';
import HedeChargeModal from './components/HedeChargeModal';
import RiderDepositList from './riderDepositList';

const formatYuan = (val) => {
    const num = Number(val);
    if (val === undefined || val === null || val === '' || Number.isNaN(num)) {
        return '0.00';
    }
    return num.toFixed(2);
};

const { Option } = Select;

const Index = (props) => {
    const [tabIndex, setTabIndex] = useState(1);
    const [visible, setVisible] = useState(false);  // 提醒设置弹窗
    const [withdrawalVisible, setWithdrawalVisible] = useState(false);  // 提现弹窗
    const [rechargeVisible, setRechargeVisible] = useState(false);  // 充值弹窗
    const [hedeChargeVisible, setHedeChargeVisible] = useState(false);  // 和德保险充值弹窗
    const [hedeAccount, setHedeAccount] = useState({});  // 和德保险预充值账户
    
    const [unionWallet, setUnionWallet] = useState({});  // 银联账户余额
    const [LLBalance, setLLBalance] = useState({}); // 连连余额账户信息
    const [LLService, setLLService] = useState({}); // 连连手续费账户信息
    const merchant = useRef(-1);  // 当前选择的服务商代付商户
    const [merchantsList, setMerchantsList] = useState([]);  // 服务商列表
    const [merchantInfo, setMerchantInfo] = useState({});  // 服务商代付商户信息
    const [behalf, setBehalf] = useState(false);  // 自动代付开关

    const [listData, setListData] = useState({dataList: []});

    const page = useRef({ pageSize: 10, pageNum: 1 });
    const [resetCode, setResetCode] = useState(0);

    const [dealTime, setDealTime] = useState([]); // 交易日期
    const [dealType, setDealType] = useState({});  // 交易类型
    const [orderCode, setOrderCode] = useState();  // 订单号

    const [dealTypeEnums, setDealTypeEnums] = useState([]);  // 交易类型枚举

    const [riderDepositAccount, setRiderDepositAccount] = useState({});

    const accountStatus = {
        NORMAL: '正常',
        CANCEL: '注销',
        LOCK: '锁定',
        LOSS: '挂失',
        ACTIVATE_PENDING: '待激活'
    };

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);

        getUnionWalletInfo();
        getPlatAccountBalance();
        getServiceMerchants();
        getRiderDepositAccount();
        getHedeBalance();
    }, []);

    useEffect(()=>{
        onSearch();
    }, [resetCode]);

    const getRiderDepositAccount = ()=>{
        apis.getRiderDepositAccount({}).then(res=>{
            setRiderDepositAccount(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 和德保险企业账户余额（单位：元）
    const getHedeBalance = ()=>{
        hedeApis.queryBalance({}).then(res=>{
            setHedeAccount(res.result || {});
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 银联钱包信息
    const getUnionWalletInfo = ()=>{
        apis.getUnionWalletInfo().then(res=>{
            setUnionWallet(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 获取连连平台账户信息  "MCHFEE_AVAILABLE": 连连手续费账户； "MCHOWN_AVAILABLE": 连连余额账户
    const getPlatAccountBalance = ()=>{
        apis.getPlatformAccountBalance().then(res=>{
            let temp = {};
            res.result.forEach(v=>{
                temp[v.acctType] = v;
            });
            setLLBalance(temp.MCHOWN_AVAILABLE);
            setLLService(temp.MCHFEE_AVAILABLE);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 身边云代付账户-服务商列表
    const getServiceMerchants = ()=>{
        apis.getYoufuServiceMerchants().then(res=>{
            setMerchantsList(res.result);
            merchant.current = res.result[0].code;
            getYoufuMerchantsAccount(res.result[0].code);
            getBehalf();
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 获取身边云代付商户账户
    const getYoufuMerchantsAccount = (id)=>{
        let params = {levyId: id};
        apis.getYoufuAccountBalance(params).then(res=>{
            setMerchantInfo(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onMerchantsChange = (val)=>{
        merchant.current = val;
    };

    // 自动代付开关状态
    const getBehalf = ()=>{
        getSystemParams({paramCode: 'YOU_FU_PAY_AUTO'}).then(res=>{
            let status = res.result == merchant.current;
            setBehalf(status);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onBehalfChange = (val)=>{
        let value = val ? merchant.current : 0;
        let params = {
            paramCode: 'YOU_FU_PAY_AUTO',
            paramValue:  value
        };
        updateSystemParams(params).then(res=>{
            setBehalf(val);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const openModal = () =>{
        setVisible(true);
    };

    const onWithdrawal = ()=>{
        setWithdrawalVisible(true);
    };

    const onRecharge = ()=>{
        setRechargeVisible(true);
    };

    const onWithdrawalOk = (data)=>{
        setWithdrawalVisible(false);
        getPlatAccountBalance();
    };

    const onRechargeOk = (data)=>{
        setRechargeVisible(false);
        getPlatAccountBalance();
    };

    const onHedeCharge = ()=>{
        setHedeChargeVisible(true);
    };

    const onHedeChargeOk = ()=>{
        setHedeChargeVisible(false);
        getHedeBalance();
    };

    // 查询
    const onSearch = (usecache) => {
        if (usecache !== 'usecache') {
            page.current = { pageNum: 1, pageSize: 10 };
        }
        let params = {
            startTime: dealTime[0] ? dealTime[0] + ' 00:00:00' : undefined,
            endTime: dealTime[1] ? dealTime[1] + ' 23:59:59' : undefined,
            dealType: dealType.code,
            orderCode,
            pageNum: usecache == 'usecache' ? page.current.pageNum : 1, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: usecache == 'usecache' ? page.current.pageSize : 5, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        
        // api fetch
    };

    const onReset = () => {
        setDealTime([]);
        setDealType({});
        setOrderCode();
        setResetCode(new Date())
        page.current = { pageNum: 1, pageSize: 5 };
    };


    const onPageChange = (pageSize, pageNum) => {
        page.current = { pageNum, pageSize };
        onSearch('usecache');
    };

    return(
        <div className={styles.container}>
            <div className={styles.warningSet}>
                <ButtonPerssion code='finance/platformwallet/cwszzhyetxsz'>
                    <SettingFilled  onClick={openModal} title="提醒设置" />
                </ButtonPerssion>
            </div>
            <div className={styles.accountWrap}>
                <div className={styles.accountBox}>
                    {unionWallet.amount > 0 ? (
                        <div className={`${styles.accountItem} ${tabIndex == 0 ? styles.active : ''}`} onClick={()=>{setTabIndex(0)}}>
                            <div className={styles.header}>
                                <span>平台收益账户（银联）</span>
                                <span>553456356746336</span>
                            </div>
                            <div className={styles.body}>
                                <div className={styles.status}><span>正常</span></div>
                                <div className={styles.normalMain}>
                                    <div className={styles.balance}><span>¥</span><strong>{regFenToYuan(unionWallet.amount)}</strong></div>
                                    <div className={styles.balanceDesc}>可用余额</div>
                                </div>
                            </div>
                            <div className={styles.footer}>
                                <span>*银联收益账户的资金 ，提现完后将不再显示</span>
                            </div>
                        </div>
                    ) : null}
                    
                    <div className={`${styles.accountItem} ${tabIndex == 1 ? styles.active : ''}`} onClick={()=>{setTabIndex(1)}}>
                        <div className={styles.header}>
                            <span>平台收益账户（连连）</span>
                            <span>2527263571630374</span>
                        </div>
                        <div className={styles.body}>
                            <div className={styles.status}><span>{accountStatus[LLBalance.status]}</span></div>
                            <div className={styles.normalMain}>
                                <Button className={styles.rightTopBtn} type="primary" onClick={onWithdrawal}>提现</Button>
                                <div className={styles.balance}><span>¥</span><strong>{regFenToYuan(LLBalance.avlblAmt)}</strong></div>
                                <div className={styles.balanceDesc}>可用余额</div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            <span>*用于在交易完成分账后平台获得收益的账户</span>
                        </div>
                    </div>

                    <div className={`${styles.accountItem} ${tabIndex == 2 ? styles.active : ''}`} onClick={()=>{setTabIndex(2)}}>
                        <div className={styles.header}>
                            <span>代付账户（身边云）</span>
                            <span>234237642749612</span>
                        </div>
                        <div className={styles.body}>
                            <div className={styles.status}><span>{accountStatus[merchantInfo.status]}</span></div>
                            <div className={styles.normalMain}>
                                <div className={styles.merchants}>
                                    <div className={styles.label}>服务商</div>
                                    <Select style={{ width: '230px' }} onChange={onMerchantsChange} value={merchant.current}>
                                        {merchantsList.map(item => <Option key={item.code} value={item.code} >{item.name}</Option>)}
                                    </Select>
                                </div>
                                <div className={styles.balance}><span>¥</span><strong>{regFenToYuan(merchantInfo.avlblAmt)}</strong></div>
                                <div className={styles.balanceDesc}>可用余额</div>
                                <div className={styles.autoPay}>
                                    <span>自动代付</span>
                                    <Switch checked={behalf} onChange={onBehalfChange} />
                                </div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            <span>*用于骑手的配送收益代发，需线下充值且保证充足</span>
                        </div>
                    </div>

                    <div className={`${styles.accountItem} ${tabIndex == 3 ? styles.active : ''}`} onClick={()=>{setTabIndex(3)}}>
                        <div className={styles.header}>
                            <span>手续费账户(连连) </span>
                            <span>2527263571697274</span>
                        </div>
                        <div className={styles.body}>
                            <div className={styles.status}><span>正常</span></div>
                            <div className={styles.normalMain}>
                                <Button className={styles.rightTopBtn} type="primary" onClick={onRecharge}>充值</Button>
                                <div className={styles.balance}><span>¥</span><strong>{regFenToYuan(LLService.avlblAmt)}</strong></div>
                                <div className={styles.balanceDesc}>可用余额</div>
                                <div className={styles.tips}>连连入金手续费账户，按金额0.5%收取</div>
                            </div>
                        </div>
                        <div className={styles.footer}>
                            <span>*连连收取交易手续费的账户，需保证资金充足</span>
                        </div>
                    </div>

                    <div className={`${styles.accountItem} ${tabIndex == 4 ? styles.active : ''}`} onClick={()=>{setTabIndex(4)}}>
                        <div className={styles.header}>
                            <span>骑手押金 </span>
                        </div>
                        <div className={styles.depositBody}>
                            <div className={styles.depositMain}>
                                <div className={styles.balance}><span>¥</span><strong>{regFenToYuan(riderDepositAccount.balance)}</strong></div>
                                <div className={styles.balanceDesc}>可用余额</div>
                            </div>
                            <div className={styles.otherAccounts}>
                                {Array.isArray(riderDepositAccount.balanceInfoList) 
                                && riderDepositAccount.balanceInfoList.map(v=>(<p key={v.payTypeName}><span>{v.payTypeName}</span><strong>¥{regFenToYuan(v.balance)}</strong></p>))}
                                
                            </div>

                        </div>
                    </div>

                    <div className={`${styles.accountItem} ${tabIndex == 5 ? styles.active : ''}`} onClick={()=>{setTabIndex(5)}}>
                        <div className={styles.header}>
                            <span>
                                和德保险预充值
                                <Tooltip
                                    overlayStyle={{ maxWidth: 380 }}
                                    title={(
                                        <div>
                                            <div>1、该账户为第三方骑手意外险购保的预充值账户；</div>
                                            <div>2、需保证余额充足，余额不足时骑手无法进行购保；</div>
                                            <div>3、充值打款时按和德保险费充值做好备注；</div>
                                            <div>4、充值消耗明细需线下让和德提供，和德可以提供保费发票。</div>
                                        </div>
                                    )}
                                >
                                    <QuestionCircleOutlined className={styles.helpIcon} onClick={(e)=>{e.stopPropagation();}} />
                                </Tooltip>
                            </span>
                        </div>
                        <div className={styles.body}>
                            <div className={styles.status}><span>正常</span></div>
                            <div className={styles.normalMain}>
                                <Button className={styles.rightTopBtn} type="primary" onClick={onHedeCharge}>充值</Button>
                                <div className={styles.balance}><span>¥</span><strong>{formatYuan(hedeAccount.balance)}</strong></div>
                                <div className={styles.balanceDesc}>可用余额</div>
                            </div>
                        </div>
                        <div className={`${styles.footer} ${styles.hedeFooter}`}>
                            <span>*骑手购保预充值账户，资金充足影响骑手购买保险</span>
                        </div>
                    </div>

                </div>
            </div>

            {[1,2,3].includes(tabIndex) ?
            <div className={styles.listContainer}>
                <FilterForm>
                    <FilterItem>
                        <XRangePicker
                            label='交易日期'
                            bindThis={setDealTime}
                            bindName='dealTime'
                            value={dealTime}
                            format="YYYY-MM-DD"
                        />
                    </FilterItem>
                    <FilterItem>
                        <XSelect
                            label='交易类型：'
                            placeholder='请选择'
                            renderData={dealTypeEnums}
                            onChange={setDealType}
                            dataIndex='value'
                            keyIndex='code'
                            value={dealType.code}
                            allowClear
                            isOptionBindID={true}
                        />
                    </FilterItem>
                    <FilterItem>
                        <XInput
                            label="订单号："
                            placeholder='请输入订单号'
                            bindThis={setOrderCode}
                            bindName='orderCode'
                            value={orderCode}
                        />
                    </FilterItem>
                    <FilterItem>
                        <Button type="primary" style={{ marginRight: '20px' }} onClick={onSearch}>查询</Button>
                        <Button style={{ marginRight: '20px' }} onClick={onReset}>重置</Button>
                    </FilterItem>
                </FilterForm>
                <div className={styles.tableContainer}>
                    <TableList renderData={listData} paginationChange={onPageChange} />
                </div>
            </div>
            : null
            }

            {tabIndex == 0 ? <div className={styles.noDataList}><span>暂无数据</span></div> : null}
            {tabIndex == 4 ? <RiderDepositList /> : null}
            {tabIndex == 5 ? <div className={styles.noDataList}><span>暂无账户明细</span></div> : null}
            {visible && <WarningModal onClose={()=>{setVisible(false);}} />}
            {withdrawalVisible && <WithdrawalModal balance={LLBalance.avlblAmt} onOk={onWithdrawalOk} onClose={()=>{setWithdrawalVisible(false)}} />}
            {rechargeVisible && <RechargeModal balance={LLService.avlblAmt} onOk={onRechargeOk} onClose={()=>{setRechargeVisible(false)}} />}
            {hedeChargeVisible && <HedeChargeModal balance={hedeAccount.balance} onOk={onHedeChargeOk} onClose={()=>{setHedeChargeVisible(false)}} />}
        </div>
    );
};

Index.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Index);